import { render, staticRenderFns } from "./commentMilestone.vue?vue&type=template&id=2a5b6296&scoped=true"
import script from "./commentMilestone.vue?vue&type=script&lang=js"
export * from "./commentMilestone.vue?vue&type=script&lang=js"
import style0 from "./commentMilestone.vue?vue&type=style&index=0&id=2a5b6296&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5b6296",
  null
  
)

export default component.exports